import {Location} from "./Location";

export class Accident {
  name?: string;
  description?: string;
  date: Date;
  district: string;
  place: string;
  location: Location;
  dead: number;
  wounded: number;
  links: Array<string>
  picture: string | undefined;
  damage: Array<string>

  constructor(
    name: string | undefined,
    description: string | undefined,
    date: Date,
    district: string,
    place: string,
    location: Location,
    dead: number,
    wounded: number,
    links: Array<string>,
    picture: string | undefined,
    damage: Array<string> = [],
  ) {
    this.name = name
    this.description = description
    this.date = date
    this.district = district
    this.place = place
    this.location = location
    this.dead = dead
    this.wounded = wounded
    this.links = links
    this.picture = picture
    this.damage = damage
  }

  public isTragedy(): boolean {
    return (this.dead !== undefined && this.dead > 0) || (this.wounded !== undefined && this.wounded > 0)
  }

  public isMiracle(): boolean {
    return (this.dead !== undefined && this.dead === 0) && (this.wounded !== undefined && this.wounded === 0)
  }
}
